// import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import React, { useState } from "react";
import message from "../../images/icons/c_message.png";
import location from "../../images/icons/c_location.png";
import phone from "../../images/icons/c_phone.png";
import contbg from "../../images/footer/contactbg.png";
import { supabase } from "../superbase/SuperbaseClient";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import Select from "react-select";
export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    contact: "", // email OR phone
    // mobile: "",
    service: "",
    packageType: "",
    startDate: "",
    endDate: "",
    // city: "",
    location: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  // Handle input updates
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  // package
  const handleSelectChange = (name, option) => {
    handleChange({
      target: {
        name,
        value: option?.value || "",
      },
    });
  };

  // Validation logic
  const validate = () => {
    let temp = {};

    if (!formData.name.trim()) temp.name = "Name is required";
    if (!formData.contact.trim()) {
      temp.contact = "Email or phone number is required";
    } else {
      const isEmail = /\S+@\S+\.\S+/.test(formData.contact);
      const isPhone = /^[0-9]{10}$/.test(formData.contact);

      if (!isEmail && !isPhone) {
        temp.contact = "Enter a valid email or 10-digit phone number";
      }
    }
    if (!formData.location.trim()) {
      temp.location = "Location is required";
    }
    // Start Date
    if (!formData.startDate) {
      temp.startDate = "Start date is required";
    }

    // End Date
    if (!formData.endDate) {
      temp.endDate = "End date is required";
    }

    // Date comparison (only if both exist)
    if (formData.startDate && formData.endDate) {
      const start = new Date(formData.startDate);
      const end = new Date(formData.endDate);

      if (end < start) {
        temp.endDate = "End date must be after start date";
      }
    }

    // if (!formData.email.trim()) temp.email = "Email is required";
    // else if (!/\S+@\S+\.\S+/.test(formData.email))
    //   temp.email = "Enter a valid email";

    // if (!formData.mobile.trim()) temp.mobile = "Mobile number is required";
    // else if (!/^[0-9]{10}$/.test(formData.mobile))
    //   temp.mobile = "Mobile must be 10 digits";

    if (!formData.service) temp.service = "Please select a service";

    if (!formData.message.trim()) temp.message = "Message is required";

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };
  // Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");

    if (!validate()) return;

    let payload = { ...formData };

    // 👇 Merge customRange into packageType
    if (payload.packageType === "custom") {
      payload.packageType = `${payload.customRange}`;
      delete payload.customRange;
    }

    setLoading(true);

    try {
      console.log("Final Payload:", payload);

      const { error } = await supabase.from("carzenform").insert([
        {
          name: formData.name,
          contact: formData.contact,
          service: formData.service,
          package_type: payload.packageType,
          start_date: formData.startDate,
          end_date: formData.endDate,
          location: formData.location,
          message: formData.message,
        },
      ]);
      console.log("form::", formData);
      // const error = formData;
      // console.log("Error :", error);
      if (error) {
        console.error("Supabase Error:", error);
        setErrors({ submit: "Failed to submit. Please try again." });
        return;
      }

      setSuccess("Your message has been sent successfully!");

      setFormData({
        name: "",
        contact: "",
        service: "",
        packageType: "",
        startDate: "",
        endDate: "",
        location: "",
        message: "",
      });
      setErrors({});
    } catch (err) {
      console.error("Unexpected Error:", err);
      setErrors({ submit: "Something went wrong. Try again later." });
    } finally {
      setLoading(false);
    }
  };
  // city options
  const cityOptions = [
    { value: "", label: "Select city", isDisabled: true },

    { value: "Mumbai", label: "Mumbai" },
    { value: "Delhi", label: "Delhi" },
    { value: "Bengaluru", label: "Bengaluru" },
    { value: "Chennai", label: "Chennai" },
    { value: "Hyderabad", label: "Hyderabad" },
    { value: "Kolkata", label: "Kolkata" },
    { value: "Pune", label: "Pune" },
    { value: "Ahmedabad", label: "Ahmedabad" },
    { value: "Jaipur", label: "Jaipur" },
    { value: "Chandigarh", label: "Chandigarh" },
    { value: "Indore", label: "Indore" },
    { value: "Bhopal", label: "Bhopal" },
    { value: "Lucknow", label: "Lucknow" },
    { value: "Kanpur", label: "Kanpur" },
    { value: "Noida", label: "Noida" },
    { value: "Gurgaon", label: "Gurgaon" },
    { value: "Faridabad", label: "Faridabad" },
    { value: "Ghaziabad", label: "Ghaziabad" },
  ];

  // package options
  const packageOptions = [
    { value: "", label: "Select package", isDisabled: true },

    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
    { value: "yearly", label: "Yearly" },
    { value: "custom", label: "Custom" },
  ];

  // service options
  const serviceOptions = [
    { value: "", label: "Select service", isDisabled: true },

    { value: "Employee Transportation", label: "Employee Transportation" },
    { value: "Airport Transfers", label: "Airport Transfers" },
    {
      value: "Event & Conference Transport",
      label: "Event & Conference Transport",
    },
    {
      value: "Outstation Business Trips",
      label: "Outstation Business Trips",
    },
  ];

  const getCitySelectStyles = (hasError) => ({
    control: (base, state) => ({
      ...base,
      backgroundColor: "transparent",
      border: "none",
      borderBottom: `1px solid ${
        hasError
          ? "#ef4444" // red-500
          : state.isFocused
          ? "#c59b61" // gold
          : "rgba(255,255,255,0.4)"
      }`,
      borderRadius: 0,
      boxShadow: "none",
      minHeight: "42px",
      color: "white",
      paddingLeft: 0,
      paddingRight: 0,
    }),

    singleValue: (base) => ({
      ...base,
      color: "white",
    }),

    placeholder: (base) => ({
      ...base,
      color: "rgba(255,255,255,0.7)",
    }),

    input: (base) => ({
      ...base,
      color: "white",
    }),

    menu: (base) => ({
      ...base,
      backgroundColor: "#6b7280", // gray-500
    }),

    menuList: (base) => ({
      ...base,
      maxHeight: "180px",
      overflowY: "auto",
    }),

    // ✅ THIS PART FIXES THE BLUE CLICK ISSUE
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#c59b61" // selected
        : state.isFocused
        ? "#9ca3af" // hover
        : "#6b7280", // default

      color: "white",
      cursor: "pointer",

      // 👇 OVERRIDE DEFAULT BLUE ACTIVE COLOR
      ":active": {
        backgroundColor: "#c59b61",
      },
    }),
  });

  return (
    <section
      id="contact us"
      className="w-full bg-white text-gray-900 flex items-stretch justify-center"
    >
      <div className="max-w-8xl w-full mx-auto  py-12 lg:py-20">
        {/* Grid layout: single column on mobile, two columns from md/lg */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 items-stretch min-h-[680px]">
          {/* Left: Contact Info */}
          <Fade direction="left" triggerOnce damping={0.2}>
            <div className="flex flex-col justify-center px-4  lg:pl-[120px]  py-8 lg:py-36 bg-white">
              <h2 className="text-2xl  lg:text-5xl font-bold leading-tight text-gray-900 mb-6 lg:mb-14">
                Let’s talk <br />
                on something <span className="text-[#c59b61]">great</span>{" "}
                <br /> together
              </h2>
              <div className="space-y-5 md:space-y-[39px] mt-8 text-gray-700">
                {" "}
                <Link
                  className="flex items-start space-x-4 md:h-[80px]"
                  to="https://mail.google.com/mail/?view=cm&fs=1&to=carzenlogistics@gmail.com&su=Corporate%20Car%20Service%20Requirement"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <img
                    src={message}
                    className="w-5 h-5 md:w-[30px] md:h-[30px] object-contain"
                    alt="gmail"
                  />{" "}
                  <p className="text-sm md:text-[18px] lg:text-[24px]">
                    {" "}
                    carzenlogistics@gmail.com{" "}
                  </p>{" "}
                </Link>{" "}
                <div className="flex items-start space-x-4 md:h-[80px]">
                  {" "}
                  <img
                    src={phone}
                    className="w-5 h-5 md:w-[30px] md:h-[30px] object-contain"
                    alt="gmail"
                  />{" "}
                  <p className="text-sm md:text-[24px] lg:mt-1">
                    +91 8123415558
                  </p>{" "}
                </div>{" "}
                <div className="flex space-x-4 md:h-[80px] items-start">
                  {" "}
                  <img
                    src={location}
                    className="w-5 h-5 md:w-[30px] md:h-[30px] object-contain"
                    alt="gmail"
                  />{" "}
                  <p className="max-w-xl text-sm md:text-[24px] leading-[20px] md:leading-[30px] ">
                    {" "}
                    Bengaluru, Karnataka{" "}
                  </p>
                </div>
              </div>
            </div>
          </Fade>

          {/* Right: Form with background image */}
          <Fade direction="right" triggerOnce damping={0.2}>
            <div
              className="relative md:h-auto flex items-center justify-center  overflow-hidden"
              style={{
                backgroundImage: contbg ? `url(${contbg})` : undefined,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              {/* dark overlay to ensure form readability */}
              <div className="absolute inset-0 bg-black/30"></div>

              {/* glass card */}
              <div className="relative z-10 w-full max-w-3xl  mx-4 my-4 sm:mx-8 md:mx-12 lg:mx-14 lg:my-14 bg-white/5 backdrop-blur-md rounded-2xl shadow-xl p-6 sm:p-8 md:p-10 lg:p-12">
                <form
                  className="space-y-4 sm:space-y-6"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  {/* Name */}
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm sm:text-base md:text-lg font-medium text-white mb-1"
                    >
                      Name
                    </label>
                    <input
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      maxLength={40}
                      placeholder="Enter your name"
                      className={`w-full border-b bg-transparent placeholder-white/70 text-white py-2 focus:outline-none focus:border-[#c59b61] transition ${
                        errors.name ? "border-red-500" : "border-white/40"
                      }`}
                    />
                    {errors.name && (
                      <p className="text-red-400 text-xs mt-1">{errors.name}</p>
                    )}
                  </div>

                  {/* Email */}

                  <div>
                    <label
                      htmlFor="contact"
                      className="block text-sm sm:text-base md:text-lg font-medium text-white mb-1"
                    >
                      Email or Phone Number
                    </label>

                    <input
                      id="contact"
                      name="contact"
                      type="text"
                      value={formData.contact}
                      onChange={handleChange}
                      placeholder="Enter email or phone number"
                      inputMode="email"
                      className={`w-full border-b bg-transparent placeholder-white/70 text-white py-2 focus:outline-none focus:border-[#c59b61] transition ${
                        errors.contact ? "border-red-500" : "border-white/40"
                      }`}
                    />

                    {errors.contact && (
                      <p className="text-red-400 text-xs mt-1">
                        {errors.contact}
                      </p>
                    )}
                  </div>

                  <div>
                    <label
                      htmlFor="location"
                      className="block text-sm sm:text-base md:text-lg font-medium text-white mb-1"
                    >
                      Location / Area
                    </label>

                    <Select
                      options={cityOptions}
                      value={
                        cityOptions.find(
                          (opt) => opt.value === formData.location
                        ) || null
                      }
                      onChange={(opt) =>
                        setFormData({ ...formData, location: opt.value })
                      }
                      styles={getCitySelectStyles(errors.location)}
                      components={{
                        IndicatorSeparator: () => null, // 👈 removes the 1px line
                      }}
                      // styles={{
                      //   menuList: (base) => ({
                      //     ...base,
                      //     maxHeight: "180px",
                      //     overflowY: "auto",
                      //   }),
                      // }}
                    />

                    {errors.location && (
                      <p className="text-red-400 text-xs mt-1">
                        {errors.location}
                      </p>
                    )}
                  </div>

                  {/* Service */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-4">
                    {/* package */}
                    <div>
                      <label
                        htmlFor="service"
                        className="block text-sm sm:text-base md:text-lg font-medium text-white mb-1"
                      >
                        Select Service
                      </label>

                      <Select
                        options={serviceOptions}
                        placeholder="Select service"
                        value={serviceOptions.find(
                          (opt) => opt.value === formData.service
                        )}
                        onChange={(option) =>
                          handleSelectChange("service", option)
                        }
                        styles={getCitySelectStyles(errors.service)}
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                      />

                      {errors.service && (
                        <p className="text-red-400 text-xs mt-1">
                          {errors.service}
                        </p>
                      )}
                    </div>

                    {/* package */}
                    <div>
                      <label className="block text-sm sm:text-base md:text-lg font-medium text-white mb-1">
                        Select Package
                      </label>

                      <Select
                        options={packageOptions}
                        placeholder="Select package"
                        value={packageOptions.find(
                          (opt) => opt.value === formData.packageType
                        )}
                        onChange={(option) =>
                          setFormData({
                            ...formData,
                            packageType: option?.value,
                          })
                        }
                        styles={getCitySelectStyles(errors.packageType)}
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                      />

                      {errors.packageType && (
                        <p className="text-red-400 text-xs mt-1">
                          {errors.packageType}
                        </p>
                      )}

                      {/* 👇 Show input only when Custom is selected */}
                      {formData.packageType === "custom" && (
                        <div className="mt-3">
                          <label className="block text-white mb-1">
                            Enter Custom Range
                          </label>

                          <input
                            type="number"
                            name="customRange"
                            placeholder="e.g: 45 days"
                            value={formData.customRange || ""}
                            onChange={handleChange}
                            className="w-full border-b bg-transparent text-white py-2
          border-white/40 focus:outline-none focus:border-[#c59b61]"
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm sm:text-base md:text-lg font-medium text-white mb-1">
                        Start Date
                      </label>
                      <input
                        type="date"
                        name="startDate"
                        value={formData.startDate}
                        onChange={handleChange}
                        className={`w-full border-b bg-transparent text-white py-2 calendar-white ${
                          errors.startDate
                            ? "border-red-500"
                            : "border-white/40"
                        }`}
                      />
                      {errors.startDate && (
                        <p className="text-red-400 text-xs">
                          {errors.startDate}
                        </p>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm sm:text-base md:text-lg font-medium text-white mb-1">
                        End Date
                      </label>
                      <input
                        type="date"
                        name="endDate"
                        value={formData.endDate}
                        onChange={handleChange}
                        className={`w-full border-b bg-transparent text-white py-2 calendar-white ${
                          errors.endDate ? "border-red-500" : "border-white/40"
                        }`}
                      />
                      {errors.endDate && (
                        <p className="text-red-400 text-xs">{errors.endDate}</p>
                      )}
                    </div>
                  </div>

                  {/* Message */}
                  <div>
                    <label
                      htmlFor="message"
                      className="block text-sm sm:text-base md:text-lg font-medium text-white mb-1"
                    >
                      How can we help you?
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      maxLength={150}
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Type here"
                      className={`w-full border-b bg-transparent placeholder-white/70 text-white py-2 focus:outline-none focus:border-[#c59b61] transition ${
                        errors.message ? "border-red-500" : "border-white/40"
                      }`}
                    />
                    {errors.message && (
                      <p className="text-red-400 text-xs mt-1">
                        {errors.message}
                      </p>
                    )}
                  </div>

                  {errors.form && (
                    <p className="text-red-400 text-sm">{errors.form}</p>
                  )}
                  {success && (
                    <p className="text-green-400 text-sm">{success}</p>
                  )}

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full mt-3 bg-white text-gray-900 font-medium py-3 rounded-full hover:bg-[#c59b61] hover:text-white transition disabled:opacity-60"
                  >
                    {loading ? "Sending..." : "Send message"}
                  </button>
                </form>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </section>
  );
}
